<app-dialog-base [Title]='"Company"|translate' [dialogId]="dialogId" (onClose)="close()" [width]="'760px'" (onSubmit)="submit()" [isSubmitDisabled]="isLoading" [isLoading]="isLoading">
    <div class="btn_tabs">
        <button (click)="openTab('companyData')"
            [class.active]="openedTabName == 'companyData'">{{"General"|translate}}</button>
        <button (click)="openTab('postSettings')" [class.active]="openedTabName == 'postSettings'">{{"Post settings"|translate}}</button>
        <button (click)="openTab('telegramSettings')" [class.active]="openedTabName == 'telegramSettings'">{{"Telegram settings"|translate}}</button>
        <button *ngIf="currentCompany" (click)="openTab('objects')" [class.active]="openedTabName == 'objects'">{{"Objects"|translate}}</button>
        <button *ngIf="currentCompany" (click)="openTab('containers')" [class.active]="openedTabName == 'containers'">{{"Containers"|translate}}</button>
    </div>
    <div class="horseparator"></div>
    <div style="padding-top: 15px;" id="userData" *ngIf="isSelected('companyData')" class="tablewrap">
        <div class="inputgroup" *ngIf="showParentCompanyField">
            <label>{{'Parent company'|translate}}</label>
            <select class="company-select" title="{{'Parent company'|translate}}" [(ngModel)]="model.ParentCompanyId">
                <option *ngFor="let company of companies" value="{{company.Id}}"
                    [selected]="model.ParentCompanyId == company.Id">
                    {{company.Name}}
                </option>
            </select>
        </div>
        <div class="inputgroup">
            <label>{{'Name'|translate }}</label>
            <input type="text" placeholder="{{'Name'|translate }}" [(ngModel)]="model.Name" />
        </div>
        <div class="inputgroup">
            <label>{{'Phone №'|translate }}</label>
            <input type="text" placeholder="{{'Phone №'|translate }}" [(ngModel)]="model.Phone" />
        </div>
        <div class="inputgroup">
            <label>{{'Email'|translate }}</label>
            <input type="text" placeholder="{{'Email'|translate }}" [(ngModel)]="model.Email" />
        </div>
        <div class="inputgroup">
            <label>{{'Postal address'|translate }}</label>
            <input type="text" placeholder="{{'Postal address'|translate }}" [(ngModel)]="model.PostAddress" />
        </div>
        <div class="inputgroup">
            <label>{{'Contact'|translate }}</label>
            <input type="text" placeholder="{{'Contact'|translate }}" [(ngModel)]="model.ContactName" />
        </div>
        <div class="inputgroup" *ngIf="model.CreatedAt">
          <label>{{'Created at'|translate}}</label>
          <label>{{model.CreatedAt | date: 'dd.MM.yyyy'}}</label>
        </div>
        <div class="inputgroup">
            <label>{{'Status'|translate}}</label>
            <select title="{{'Status'|translate}}" [(ngModel)]="model.CompanyStatus">
                <option [ngValue]="0">{{'Blocked Company'|translate}}</option>
                <option [ngValue]="1">{{'Active Company'|translate}}</option>
            </select>
        </div>
        <div class="inputgroup">
            <label>{{'Timezone'|translate}}</label>
            <select style="width: 100%;" title="{{'Timezone'|translate}}" [(ngModel)]="model.TimeZone">
              <option *ngFor="let timezone of timezones" value="{{timezone.Name}}"
                [selected]="model.TimeZone === timezone.Name">
                {{timezone.DisplayName}}
              </option>
            </select>
          </div>
    </div>
    <div id="postSettings" style="padding-top: 15px;" *ngIf="isSelected('postSettings')" class="tablewrap">
        <br />
        <div class="inputgroup">
            <label>{{'Server'|translate }}</label>
            <input type="text" placeholder="{{'Server'|translate }}"  [(ngModel)]="externalAPI.emailSettings.smtpHost" />
        </div>
        <div class="inputgroup">
            <label>{{'Port'|translate }}</label>
            <input type="text" placeholder="{{'Port'|translate }}" [(ngModel)]="externalAPI.emailSettings.smtpPort" />
        </div>
        <div class="inputgroup">
            <label>{{'SSL'|translate}}</label>
            <input type="checkbox" [(ngModel)]="externalAPI.emailSettings.ssl" />
        </div>
        <div class="inputgroup">
            <label>{{'User'|translate }}</label>
            <input type="text" placeholder="{{'User'|translate }}" [(ngModel)]="externalAPI.emailSettings.user" />
        </div>
        <div class="inputgroup">
            <label>{{'Password'|translate }}</label>
            <input type="password" placeholder="{{'Password'|translate }}" [(ngModel)]="externalAPI.emailSettings.password" />
        </div>
        <div class="inputgroup">
            <label>{{'From email'|translate }}</label>
            <input type="text" placeholder="{{'From email'|translate }}" [(ngModel)]="externalAPI.emailSettings.from" />
        </div>
        <div class="inputgroup">
            <label>{{'Text'|translate}}</label>
            <textarea [(ngModel)]="externalAPI.emailSettings.text"></textarea>
        </div>
        <div class="inputgroup">
            <label>{{'Override SMTP notification settings' | translate}}</label>
            <input type="checkbox" [(ngModel)]="externalAPI.emailSettings.enabled" />
        </div>
    </div>
    <div id="telegramSettings" style="padding-top: 15px;" *ngIf="isSelected('telegramSettings')" class="tablewrap">
        <div class="inputgroup">
            <label>{{'Token'|translate }}</label>
            <input type="text" placeholder="{{'Token'|translate }}" [(ngModel)]="externalAPI.telegramSettings.token" />
        </div>
        <div class="inputgroup">
            <label>{{'Override telegram notification settings' | translate}}</label>
            <input type="checkbox" [(ngModel)]="externalAPI.telegramSettings.enabled" />
        </div>
    </div>
    <div id="objects" *ngIf="isSelected('objects')" class="tablewrap modalcreateuser">
        <app-entities-list-company-orchestrator  [currentCompany]="currentCompany">

        </app-entities-list-company-orchestrator>
    </div>
    <div id="containers" *ngIf="isSelected('containers')" class="tablewrap">
        <div class="company-containers-tab">
            <div class="containers-toolbar">
                <input class="searchinput" type="text" placeholder="{{'Find by name'|translate}}" [(ngModel)]="containersFilter" />
                <button  class="btnadd" style="padding-left: 20px;" type="button" (click)="openCreateContainer()">
            </button>
            </div>

            <div class="containers-list-panel">
                <div class="table">
                    <table>
                        <thead>
                            <tr>
                                <th>{{'Name'|translate}}</th>
                                <th class="containers-actions-col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let container of filteredCompanyContainers"
                                [class.active]="selectedContainer?.Id === container.Id"
                                (click)="selectContainer(container)">
                                <td>{{container.Name}}</td>
                                <td  class="containers-actions-col">
                                    <button class="btn_img btn_edit" type="button"
                                            title="{{'Edit'|translate}}"
                                            (click)="openEditContainer(container, $event)"></button>
                                    <button class="btn_img btn_trush" type="button"
                                            title="{{'Delete'|translate}}"
                                            (click)="deleteContainer(container, $event)"></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="empty-company-containers" *ngIf="filteredCompanyContainers.length == 0">
                    {{'No containers'|translate}}
                </div>
            </div>
        </div>
    </div>
</app-dialog-base>
<app-container-access [companyId]="currentCompany?.Id || 0"
                      [companyName]="currentCompany?.Name || ''"
                      (containersChanged)="onContainersChanged()"></app-container-access>
